const selectOutlinedColors: object = {
  "blue-gray": {
    close: {
      borderColor: "border-blue-gray-200",
    },
    open: {
      borderColor: "border-blue-gray-500",
      borderTopColor: "border-t-transparent",
    },
    withValue: {
      borderColor: "border-blue-gray-200",
      borderTopColor: "border-t-transparent",
    },
  },
  gray: {
    close: {
      borderColor: "border-blue-gray-200",
    },
    open: {
      borderColor: "border-gray-900",
      borderTopColor: "border-t-transparent",
    },
    withValue: {
      borderColor: "border-blue-gray-200",
      borderTopColor: "border-t-transparent",
    },
  },
  brown: {
    close: {
      borderColor: "border-blue-gray-200",
    },
    open: {
      borderColor: "border-brown-500",
      borderTopColor: "border-t-transparent",
    },
    withValue: {
      borderColor: "border-blue-gray-200",
      borderTopColor: "border-t-transparent",
    },
  },
  "deep-orange": {
    close: {
      borderColor: "border-blue-gray-200",
    },
    open: {
      borderColor: "border-deep-orange-500",
      borderTopColor: "border-t-transparent",
    },
    withValue: {
      borderColor: "border-blue-gray-200",
      borderTopColor: "border-t-transparent",
    },
  },
  orange: {
    close: {
      borderColor: "border-blue-gray-200",
    },
    open: {
      borderColor: "border-orange-500",
      borderTopColor: "border-t-transparent",
    },
    withValue: {
      borderColor: "border-blue-gray-200",
      borderTopColor: "border-t-transparent",
    },
  },
  amber: {
    close: {
      borderColor: "border-blue-gray-200",
    },
    open: {
      borderColor: "border-amber-500",
      borderTopColor: "border-t-transparent",
    },
    withValue: {
      borderColor: "border-blue-gray-200",
      borderTopColor: "border-t-transparent",
    },
  },
  yellow: {
    close: {
      borderColor: "border-blue-gray-200",
    },
    open: {
      borderColor: "border-yellow-500",
      borderTopColor: "border-t-transparent",
    },
    withValue: {
      borderColor: "border-blue-gray-200",
      borderTopColor: "border-t-transparent",
    },
  },
  lime: {
    close: {
      borderColor: "border-blue-gray-200",
    },
    open: {
      borderColor: "border-lime-500",
      borderTopColor: "border-t-transparent",
    },
    withValue: {
      borderColor: "border-blue-gray-200",
      borderTopColor: "border-t-transparent",
    },
  },
  "light-green": {
    close: {
      borderColor: "border-blue-gray-200",
    },
    open: {
      borderColor: "border-light-green-500",
      borderTopColor: "border-t-transparent",
    },
    withValue: {
      borderColor: "border-blue-gray-200",
      borderTopColor: "border-t-transparent",
    },
  },
  green: {
    close: {
      borderColor: "border-blue-gray-200",
    },
    open: {
      borderColor: "border-green-500",
      borderTopColor: "border-t-transparent",
    },
    withValue: {
      borderColor: "border-blue-gray-200",
      borderTopColor: "border-t-transparent",
    },
  },
  teal: {
    close: {
      borderColor: "border-blue-gray-200",
    },
    open: {
      borderColor: "border-teal-500",
      borderTopColor: "border-t-transparent",
    },
    withValue: {
      borderColor: "border-blue-gray-200",
      borderTopColor: "border-t-transparent",
    },
  },
  cyan: {
    close: {
      borderColor: "border-blue-gray-200",
    },
    open: {
      borderColor: "border-cyan-500",
      borderTopColor: "border-t-transparent",
    },
    withValue: {
      borderColor: "border-blue-gray-200",
      borderTopColor: "border-t-transparent",
    },
  },
  "light-blue": {
    close: {
      borderColor: "border-blue-gray-200",
    },
    open: {
      borderColor: "border-light-blue-500",
      borderTopColor: "border-t-transparent",
    },
    withValue: {
      borderColor: "border-blue-gray-200",
      borderTopColor: "border-t-transparent",
    },
  },
  blue: {
    close: {
      borderColor: "border-blue-gray-200",
    },
    open: {
      borderColor: "border-blue-500",
      borderTopColor: "border-t-transparent",
    },
    withValue: {
      borderColor: "border-blue-gray-200",
      borderTopColor: "border-t-transparent",
    },
  },
  indigo: {
    close: {
      borderColor: "border-blue-gray-200",
    },
    open: {
      borderColor: "border-indigo-500",
      borderTopColor: "border-t-transparent",
    },
    withValue: {
      borderColor: "border-blue-gray-200",
      borderTopColor: "border-t-transparent",
    },
  },
  "deep-purple": {
    close: {
      borderColor: "border-blue-gray-200",
    },
    open: {
      borderColor: "border-deep-purple-500",
      borderTopColor: "border-t-transparent",
    },
    withValue: {
      borderColor: "border-blue-gray-200",
      borderTopColor: "border-t-transparent",
    },
  },
  purple: {
    close: {
      borderColor: "border-blue-gray-200",
    },
    open: {
      borderColor: "border-purple-500",
      borderTopColor: "border-t-transparent",
    },
    withValue: {
      borderColor: "border-blue-gray-200",
      borderTopColor: "border-t-transparent",
    },
  },
  pink: {
    close: {
      borderColor: "border-blue-gray-200",
    },
    open: {
      borderColor: "border-pink-500",
      borderTopColor: "border-t-transparent",
    },
    withValue: {
      borderColor: "border-blue-gray-200",
      borderTopColor: "border-t-transparent",
    },
  },
  red: {
    close: {
      borderColor: "border-blue-gray-200",
    },
    open: {
      borderColor: "border-red-500",
      borderTopColor: "border-t-transparent",
    },
    withValue: {
      borderColor: "border-blue-gray-200",
      borderTopColor: "border-t-transparent",
    },
  },
};

export default selectOutlinedColors;
